export const iconFontAwesomeMaritimeAnchorCircleExclamation = (
	<i className="fa-solid fa-anchor-circle-exclamation"></i>
);
